import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getMeters = async (facilityId, officeId, typeId, searchString) => {
  return await request.get(
    `/RentPlace/meter`,
    { facilityId, officeId, typeId, searchString },
    'При загрузке счетчиков произошла ошибка',
    []
  );
};

const useMeters = (facilityId, officeId, typeId, searchString) =>
  useQuery(
    [queries.meters],
    () => getMeters(facilityId, officeId, typeId, searchString),
    {
      placeholderData: [],
    }
  );

export default useMeters;
